import { z } from "zod";
import { vinSchema } from "@qivia/schemas-shared";
import { dataPointsForwardDestinationSchema } from "../_shared";

export const stopDataPointsForwardPayloadSchema = z.object({
  vin: vinSchema,
  destination: dataPointsForwardDestinationSchema,
  endAt: z.iso.datetime(),
});

export type StopDataPointsForwardPayload = z.infer<
  typeof stopDataPointsForwardPayloadSchema
>;
